export default __webpack_public_path__ + "static/media/codequizapp.03fcff92.png";